import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../shared/services/settings.service';
import { ProviderWebsiteModel } from '@admin/shared/models/provider-website-model';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'hr-info-pages',
  templateUrl: './info-pages.component.html',
  styleUrls: ['./info-pages.component.less'],
  standalone: false,
})
export class InfoPagesComponent implements OnInit {
  public providerWebsites: ProviderWebsiteModel[];

  public titleData: {
    title: string;
    alias: string;
    siteAliasRequired: boolean;
  }[] = [
    { title: 'ContactUsNow', alias: 'contact-us-', siteAliasRequired: true },
    { title: 'AboutOurCompany', alias: 'about-', siteAliasRequired: true },
    { title: 'ProductsAndPrices', alias: 'services-', siteAliasRequired: true },
    {
      title: 'Outsourcing_Outstaffing',
      alias: 'outsource-',
      siteAliasRequired: true,
    },
    {
      title: 'FrequentlyAskedQuestions',
      alias: 'frequently-asked-questions-',
      siteAliasRequired: true,
    },
  ];

  constructor(
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.providerWebsites = [];
  }

  ngOnInit() {
    this.settingsService.GetActiveProviderWebsites().subscribe((website) => {
      this.providerWebsites = website.items;
    });
  }

  public onEdit(
    providerWebsiteId: number,
    providerWebsiteName: string,
    infoTitle: string
  ) {
    let alias = this.aliasBuilder(infoTitle, providerWebsiteName);
    this.router.navigate([
      './settings/info-pages-edit',
      providerWebsiteId,
      providerWebsiteName,
      infoTitle,
      alias,
    ]);
  }

  private aliasBuilder(infoTitle: string, providerWebsiteName: string): string {
    let alias: string;
    this.titleData.forEach((t) => {
      if (t.title === infoTitle) {
        if (t.siteAliasRequired) {
          let tmp = t.alias.concat(
            providerWebsiteName.replace('.', '-').toLocaleLowerCase()
          );
          alias = tmp;
        } else alias = t.alias;
      }
    });
    return alias;
  }
}
